import { beelajarServices } from './beelajar.api';
import { dacumServices } from './dacum.api';
import { hcServices } from './hc.api';
import { lcmsServices } from './lcms.api';
import { sharepointServices } from './sharepoint.api';

export const BASE_URL = process.env.REACT_APP_API_URL || 'https://uat-api2.apps.binus.edu/dacum2';

export const API_ENDPOINTS = {
  MSAL_LOGIN: '/auth/token-msal',
  VERIFY_TOKEN: '/auth/verify',

  MASTER_GROUP: {
    LIST: '/master-group-question/get-list',
    DETAIL: (id: string) => `/master-group-question/detail/${id}`,
    CREATE: '/master-group-question/add',
    UPDATE: '/master-group-question/update',
    DELETE: '/master-group-question/delete'
  },

  MASTER_QUESTION: {
    LIST: '/master-question/get-list',
    DETAIL: (id: string) => `/master-question/detail/${id}`,
    EXTERNAL_QUESTION_TYPE_LIST: '/master-question/get-external-question-type-list',
    CREATE: '/master-question/add',
    UPDATE: '/master-question/update',
    DELETE: '/master-question/delete',
    COPY: '/master-question/copy'
  },

  MODULE: {
    LIST: '/master/module'
  },

  DATA_BINUS: {
    SEARCHPARTICIPANT: '/participant/search',
    SEARCHPARTICIPANT_HC: '/participants/generate-hc',
    EMPLEC_LIST: '/emplec/get-list',
    RESPONDENT_LIST: '/respondent/get-list',
    RESPONDENT_BULK_GENERATE: '/respondent/generate-bulk'
  },

  ASSESSMENT_SCHEDULE: {
    LIST: '/assessment-schedules/get-list',
    DETAIL: (id: string) => `/assessment-schedules/detail/${id}`,
    CREATE: '/assessment-schedules/add',
    UPDATE: '/assessment-schedules/update',
    DELETE: '/assessment-schedules/delete',
    COPY: (id: string) => `/assessment-schedules/copy/${id}`,
    PUBLIC_LIST: (encryptedEmail: string) =>
      `/assessment-schedules/public/get-list/${encryptedEmail}`,
    PUBLIC_DETAIL_BY_EMAIL: (encryptedEmail: string) =>
      `/assessment-schedules/public/detail/${encryptedEmail}`,
    PUBLIC_SUBMIT_BY_EMAIL: '/assessment-schedules/submit',
    EXTERNAL_DETAIL: '/assessment-schedules/external/detail',
    UPLOAD_MODULE_EVIDENCE: '/assessment-schedules/upload-module-evidence',
    SME_SUBMIT: '/assessment-schedules/submit/evidence/validate/',
    SME_DETAIL: (id: string) => `/assessment-schedules/sme/detail/${id}`,
    SEARCH_COURSE: '/assessment-schedules/search-courses',
    LIST_MODULE: '/assessment-schedules/list-module',
    SUMMARY_REPORT_GET: '/assessment-schedules/summary-report/get-list',
    SUMMARY_REPORT_ADD: '/assessment-schedules/summary-report/add',
    SUMMARY_REPORT_UPDATE: '/assessment-schedules/summary-report/update'
  },

  YEARLY_CALENDAR: {
    LIST: '/yearly-calendar/planning/get-list',
    APPROVE_PLANNING: '/yearly-calendar/planning/approve',
    UPDATE_COURSE_STATUS: '/yearly-calendar/planning/updatestatus',
    COURSE_REPORTS: '/yearly-calendar/course/get-list'
  },

  LIA_OVERVIEW: {
    GET_OVERVIEW: '/lia/overview',
    GET_BY_STATUS: (status: string) => `/lia/assessments/status/${status}`,
    GET_COMPARISON: (beforeId: string, afterId: string) =>
      `/lia/assessments/comparison/${beforeId}/${afterId}`,
    GET_ANALYTICS: (assessmentId: string) => `/lia/assessments/${assessmentId}/analytics`,
    REFRESH_STATUS: (assessmentId: string) => `/lia/assessments/${assessmentId}/refresh-status`
  },

  MASTER_CATEGORY: {
    LIST: '/master-category/get-list'
  },

  EMPLOYEE: {
    GET_LIST_BU: '/employee/get-list-bu',
    GET_LIST_BAND: '/employee/get-list-band',
    GET_LIST_EMPLOYEE: '/employee/get-list-employee'
  },

  LECTURER: {
    GET_LIST_FAKULTAS: '/lecturer/get-list-fakultas',
    GET_LIST_LEVEL: '/lecturer/get-list-level',
    GET_LIST_LECTURER: '/lecturer/get-list-lecturer'
  },

  RANGE_TEMPLATE: {
    LIST: '/range-template/get-list',
    DETAIL: (id: string) => `/range-template/detail/${id}`,
    CREATE: '/range-template/add',
    UPDATE: '/range-template/update',
    DELETE: '/range-template/delete'
  },
  MASTER_AREA: {
    LIST: '/master-area/get-list',
    DETAIL: (id: string) => `/master-area/detail/${id}`,
    CREATE: '/master-area/add',
    UPDATE: '/master-area/update',
    DELETE: '/master-area/delete'
  },

  MASTER_USER_ADMIN: {
    LIST: '/master-useradmin/get-list',
    DETAIL: (id: string) => `/master-useradmin/detail/${id}`,
    CREATE: '/master-useradmin/add',
    UPDATE: '/master-useradmin/update',
    DELETE: '/master-useradmin/delete'
  },
  ...lcmsServices,
  ...dacumServices,
  ...hcServices,
  ...sharepointServices,
  ...beelajarServices
};

export interface ApiError {
  status: number;
  message: string;
  errors?: Record<string, string[]>;
}

export interface ApiResponse<T> {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  message: string;
  data: T[];
}

export interface MasterGroup {
  msGroupQuestionID: string;
  title: string;
  desc: string;
  moduleID: string;
  userIn: string;
  userUp: string;
  dateIn: string;
  dateUp: string;
  isDeleted: boolean;
}

export interface CreateMasterGroupDto {
  title: string;
  desc: string;
  moduleID: string;
}

export interface UpdateMasterGroupDto extends CreateMasterGroupDto {
  msGroupQuestionID: string;
}

export interface MasterQuestion {
  msQuestionID: string;
  title: string;
  category: string;
  description?: string;
  type: 'Choose One' | 'Range' | 'Free-text';
  msGroupQuestionID: string;
  sequence: number;
  isDeleted: boolean;
  dateIn: string;
  dateUp: string;
  userIn: string;
  userUp: string;
  rangeItems?: RangeItem[];
}

export interface RangeItem {
  label: string;
  value: string;
  sequence: number;
}

export interface CreateMasterQuestionDto {
  Title: string;
  Category: string;
  SkalaCategory?: string;
  Description?: string;
  Type: 'Choose One' | 'Range' | 'Free-text';
  MsGroupQuestionID: string;
  Sequence?: number;
  RangeItem?: RangeItem[];
}

export interface UpdateMasterQuestionDto extends CreateMasterQuestionDto {
  MsQuestionID: string;
}

export interface ListParticipant {
  binusianId: string;
  name: string;
  email: string;
  photoUrl: string;
  division: string;
  type?: 'Peer' | 'Supervisor' | 'Subordinate';
}

export interface MasterArea {
  areaID: string;
  areaName: string;
  areaCode: string;
  userIn: string;
  userUp: string | null;
  dateIn: string;
  dateUp: string;
}

export interface CreateMasterAreaDto {
  areaName: string;
  areaCode: string;
}

export interface UpdateMasterAreaDto extends CreateMasterAreaDto {
  areaID: string;
}

export interface MasterUserAdmin {
  msUserAdminID: string;
  adminID: string;
  adminName: string;
  adminEmail: string;
  beelajarEmail?: string;
  department?: string;
  role?: string;
  listArea?: { areaId: string; areaName?: string }[];
  areaId: string;
  areaName?: string;
  userIn: string;
  userUp: string | null;
  dateIn: string;
  dateUp: string;
}

export interface CreateMasterUserAdminDto {
  adminId: string;
  adminName: string;
  adminEmail: string;
  beelajarEmail?: string;
  department: string;
  role: string;
  listArea: { areaId: string }[];
}

export interface UpdateMasterUserAdminDto extends CreateMasterUserAdminDto {
  msUserAdminId: string;
}

export interface EmplecUser {
  binusianId: string;
  name: string;
  email: string;
  bu?: string | null;
  namaDiv?: string | null;
  level?: string | null;
  fakultas?: string | null;
}

export interface EmplecResponse {
  employees: ApiResponse<EmplecUser[]>;
  lecturers: ApiResponse<EmplecUser[]>;
}
